import type {
  GetSensorPageRequest,
  ResponseError,
  SensorPage,
} from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

export const getSensorPageKey = (organizationId: string) => [
  organizationId,
  'rendall',
  'get-sensor-page',
];

export function useSensorPage<Data = SensorPage>(
  options?: Omit<
    UseQueryOptions<SensorPage, ResponseError, Data>,
    'queryFn' | 'queryKey'
  >,
) {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();
  const organizationId = selectedOrganization.id;

  return useQuery({
    queryFn: ({ signal }) => {
      const requestObject: GetSensorPageRequest = {
        organizationId,
      };

      return api.getSensorPage(requestObject, { signal });
    },
    queryKey: getSensorPageKey(organizationId),
    ...options,
  });
}
